import { createContext, useContext, useMemo } from 'react';
import { IEvent, IEventPublisher } from '@cp/shared/cqrs';

const ctx = createContext<IEventPublisher<any>>({
   
  subscribe: () => () => {
    console.debug('[EventPublisher] subscribe before init');
  },
});

export const EventPublisherContext = ctx.Provider;

export const useEventBusSubscribe = <T extends IEvent = IEvent>() => {
  const publisher: IEventPublisher<T> = useContext(ctx);
  return useMemo(() => publisher.subscribe.bind(publisher), [publisher]);
};
